export default "__VITE_ASSET__af420f94__"